import { Form, Input, Button, Row, Col, Card } from 'antd';
import { SolutionOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { userActions } from '../../redux/actions/userAction';
import Utility, { notifyType, notifyPlacement } from '../../helper/utility';
import securityRepo from '../../repository/securityRepo';
import handleRsponse from '../../helper/handleRsponse';
const RegisterCode = (props) => {
    let codeInput = null;
    const [isLoaded, setIsLoaded] = useState(true);
    useEffect(() => {
        codeInput.focus();
    })
    const onFinish = (values) => {
        console.log('Success:', values.smsCode);
        console.log(props.currentMobile);
        login(props.currentMobile, values.smsCode);
        // props.history.push('/registerAddress');        
        //props.updateUser({'cityName':'تهران','cityId':1,'firstName':'سامان'});
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const login = (mobile, smsCode) => {
        handleRsponse.handleAxios(securityRepo.login({ 'mobile': mobile, 'smsCode': smsCode }), afterLogin, setIsLoaded)
    }
    const afterLogin = (response) => {
        if (response.status === 200) {
            console.log(response);
            props.setCurrentUser(response.data.data);
            setTimeout(() => {
                props.history.push('/registerAddress');
            }, 100);
        }        
    }
    return (
        <Row style={{ position: 'relative', top: '100px' }}>
            <Col xs={{ span: 18, offset: 3 }} lg={{ span: 8, offset: 8 }}>
                <Card>
                    <Form
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <div style={{ textAlign: 'right', paddingBottom: '15px' }}>
                            <b>لطفا کد خود را وارد نمایید</b>
                        </div>

                        <Form.Item
                            name="smsCode"
                            rules={[
                                {
                                    required: true,
                                    message: 'لطفا کد خود را وارد نمایید!',
                                },
                            ]}
                        >
                            <Input placeholder="کد" prefix={<SolutionOutlined />} maxLength="8"  style={{borderRadius:'35px'}}
                                ref={(text) => { codeInput = text; }} />
                        </Form.Item>
                        <br />
                        <Form.Item>

                            <Button type="primary" danger htmlType="submit" shape="round" size='large' className='serviceType' block disabled={!isLoaded}>
                                ارسال کد تایید
                            </Button>
                            <br />
                            <NavLink activeClassName="active" danger to="/login">تغییر شماره تماس</NavLink>
                        </Form.Item>
                        {(!isLoaded) ? <span>منتظر بمانید...</span> : ''}
                    </Form>
                </Card>
            </Col>
        </Row>

    );
}
const mapStateToProps = state => ({
    logined: state.user.isAuthenticate,
    userInfo: state.user.userInfo,
    currentMobile: state.user.currentMobile
});
const mapActionCreateor = {
    setCurrentUser: userActions.setCurrentUser,
}
//export default RegisterCode;
export default connect(mapStateToProps, mapActionCreateor)(RegisterCode)    